import { Fragment, useState, useContext, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import TokenHandle from "../../context/TokenHandle";
import { DateTime } from "luxon";

function ModalWithdraw({ onClick }) {
  const { userData } = useContext(TokenHandle);
  const [open, setOpen] = useState(false);
  const [time, settime] = useState(0)
  const [istime, issettime] = useState(0)


  const [timerDays, setTimerDays] = useState("00");
  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");
  const [CANPLAY, setCanplay] = useState(true);

  let interval;
  const startTimer = (date) => {
    const target = date;
    interval = setInterval(() => {
      const distance = target.diffNow() > 0 ? target.diffNow() : 0;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if (distance < 0) {
        clearInterval(interval);
      } else {
        setTimerDays(days);
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);
  };

  useEffect(() => {
    startTimer(DateTime.now().plus({ days: 1 }));
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    
    if(userData.checkpoint==0)
    return

    
    
    const checkpoint = DateTime.fromSeconds(userData.checkpoint).plus({hours:24})//plus({days:1})
    const current = DateTime.now()

    

    if(checkpoint>current)
    {
      const res=checkpoint.diff(current,["hours","minutes"])
      const show =`${res.hours} h: ${res.minutes.toFixed(1)} min`
      console.log(show)
      settime(show)
    }
    issettime(current>checkpoint)

    
    // console.log(checkpoint);
    return () => {
      
    }
  }, [userData])

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="mt-3 w-full inline-flex items-center justify-center px-4 py-3 border border-transparent shadow-sm font-medium rounded-md rounded-md bg-gradient-to-tr from-blue-700 to-blue-500  text-white font-medium text-center hover:from-blue-800 hover:to-blue-600"
      >
        Withdraw Now
      </button>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={setOpen}
          style={{ zIndex: "999999" }}
        >
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white border-2 border-gray-100 rounded-lg px-8 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full w-96 sm:p-6">
                <div>
                  <div className="mt-3 text-center sm:mt-5">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 font-medium text-slate-900"
                    >
                      Info
                    </Dialog.Title>
                    <div className="mt-2">
                      {istime ? (
                        <p className="text-sm text-slate-800">
                          Ready for withdraw
                        </p>
                      ) : (
                        <p className="text-sm text-slate-700">
                          You withdrew {time}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6">
                  <button
                    type="button"
                    disabled={!istime}
                    className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium  bg-blue-500 hover:bg-blue-600 text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
                    onClick={onClick}
                  >
                    Withdraw
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

export default ModalWithdraw;
